export default __webpack_public_path__ + "static/media/dna5.85937f32.png";